import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { SocketService } from '../../../socket.service';
import { ChatbotService } from './chatbot/chatbot.service';
import { LocalServiceService } from '../../services/local-service.service';

type ChatConfig = {
  lockChat?: boolean;
  style: 'old' | 'wizard';
  separateChatsByType?: boolean;
};

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
})
export class ChatComponent implements OnInit {
  activeSubFeature: string = 'Chatbot';
  channelListCategory: string = 'Main';
  showChatBox: boolean = true;

  @Input()
  currentlyTalkingTo = null;

  @Input()
  chatConfig: ChatConfig = {
    lockChat: false,
    style: 'old',
    separateChatsByType: false,
  };

  @Input()
  forTypeId = null;

  @Input()
  forCategoryId = null;

  @Input()
  isAdmin = false;

  public isConnected: boolean = false;

  constructor(
    private socketService: SocketService,
    private chatService: ChatbotService,
    private local: LocalServiceService,
  ) {
    //console.log('currentlyTalkingto=', this.currentlyTalkingTo)
    socketService.connectionSubject.subscribe((val) => {
      this.isConnected = val;
      // this.cdr?.detectChanges();
    });
    this.isConnected = socketService.isConnected;
  }

  chatMode: 'Main' | 'Archive' = 'Main';

  setMode(newVal: 'Main' | 'Archive'): void {
    this.chatMode = newVal;
  }

  ngOnInit(): void {
    this.chatService.getAllChats(this.chatConfig.separateChatsByType);
    this.chatService.getBlockedList();
  }

  refreshChat() {
    this.socketService.init();
  }

  setFeature(feature: string, category: string | null, dropdown: any) {
    this.activeSubFeature = feature;
    if (category) {
      this.channelListCategory = category;
    }
    dropdown.close(); // Close the dropdown
  }
  test() {
    console.log('scroll');
  }
}
